<template>
  <v-dialog v-model="visible" persistent max-width="360">
    <v-card class="request-permissions-card">
      <template v-if="!rejectionCount">
        <v-card-title>{{ $t('开通文件访问权限') }}</v-card-title>
        <v-card-text>{{ $t('为了保证正常预览文件，请允许{name}对文件的访问权限', { name: displayName }) }} {{ ``
        }}</v-card-text>
        <v-card-actions>
          <v-btn flat color="#909399" @click="handleCancel">{{ $t('暂不') }}</v-btn>
          <v-btn flat color="info" @click="handleGoto">{{ $t('去授权') }}</v-btn>
        </v-card-actions>
      </template>
      <template v-else>
        <v-card-title>{{ $t('拒绝授权') }}</v-card-title>
        <v-card-text>{{ $t('拒绝授权后，{name}将无法帮助您浏览、保存本机文档，请重新授权', { name: displayName }) }}</v-card-text>
        <v-card-actions>
          <v-btn flat color="#909399" @click="handleCancel">{{ $t('不，谢谢') }}</v-btn>
          <v-btn flat color="info" @click="handleGoto">{{ $t('去授权') }}</v-btn>
        </v-card-actions>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'iDS-RequestStorage',
  data() {
    return {
      rejectionCount: 0, // 拒绝次数，首次拒绝时，告知拒绝授权后的影响
    }
  },
  computed: {
    ...mapGetters('app', ['displayName']),
    ...mapGetters('app', {
      requestStorage: 'getRequestStorage',
    }),
    visible: {
      get() {
        return this.requestStorage.visible
      },
      set(value) {
        this.$store.commit('app/setRequestStorage', { value: { visible: value } })
      }
    }
  },
  watch: {
    '$route.name': function (newVal, oldVal) {
      this.handleCancel()
    },
    visible: function (newVal, oldVal) {
      this.rejectionCount = 0
    },
  },
  methods: {
    handleCancel() {
      if (!this.rejectionCount) {
        this.rejectionCount++
      } else {
        this.visible = false
        if (typeof this.requestStorage.callback === 'function') {
          this.requestStorage.callback(false)
        }
      }
    },
    handleGoto() {
      this.visible = false
      if (typeof this.requestStorage.callback === 'function') {
        this.requestStorage.callback(true)
      }
    },
  },
}
</script>

<style lang="scss">
.v-card.request-permissions-card {
  border-radius: 16px;

  .v-card__title {
    font-size: 16px;
    font-weight: bold;
  }

  .v-card__text {
    padding: 4px 16px;
  }

  .v-card__actions {
    justify-content: space-evenly;
  }
}
</style>